import React from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import style from './style.module.css';
import Modal from 'react-modal';
import 'react-lazy-load-image-component/src/effects/blur.css';

@inject(store => {
    const { myShopApiStore, ifaceMngr } = store;
    return { myShopApiStore, ifaceMngr };
})
@observer
class UpdatedModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalStyle = {
            content : {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '20px',
                // width: '30%',
                width: '365px',
                //height: '275px', 
                overflow: 'hidden',
                
            },
            overlay: {
                backgroundColor: "rgb(0, 0, 0, 0.65)",
                zIndex: 10
            }
        }
    }
    
    handleCodeChange = (e) => {
        const { name, value } = e.target;

        if(value.length && !value.match(/\D/)){
            this.setState({[name]: value.slice(-1)});
        }
    }

    handleClick = () => {
        this.props.closeModal();
        //this.props.myShopApiStore.clearReadyToOrderCartItems();
        this.props.ifaceMngr.setActiveTopMenu("ShopMenu");
    }
    
    render() {
        const { modalIsOpen, t } = this.props;
        const { shop } = this.props.myShopApiStore;
        return (
            <Modal style={this.modalStyle} isOpen={modalIsOpen} onRequestClose={this.handleClick}>
                <div className={style.ModalContainer}>
                    <div className={style.CloseBtn}>
                        <span onClick={this.handleClick}>✕</span>
                    </div>
                    <div className={style.Body}>
                        <div className={style.ModalTitle}>
                            <span>{t('Parameters updated successfully')}!</span>
                        </div>
                    </div>
                    <div className={style.ContinueBtn}>
                        <span onClick={this.handleClick}>{t('continue')}</span>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default withTranslation()(UpdatedModal);